// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"329":"layouts__sandbox__sandbox","857":"p__landing__index"}[chunkId] || chunkId) + ".async.js";
};